<template>
  <div>
    <div class="plantht">
      <div class="planttxt" style="min-height: 500px">
        <h5 class="planth5">大盘研究</h5>
        <div class="imgcontainer">
          <div
            style="padding: 17px 10px 10px 10px; margin-top: 20px"
            class="imgtop"
          >
            <TextTop></TextTop>
          </div>
          <div class="container">
            <div class="left_part">
              <ul>
                <li
                  v-for="(item, index) in leftList"
                  :key="index"
                  @click="select(item.idx)"
                  :class="selectIndex == item.idx ? 'active' : ''"
                >
                  <a>{{ item.name }}</a>
                </li>
              </ul>
            </div>
            <div class="right_part" ref="box">
              
              <div v-if="showlist[0]">
                <p class="title" id="id3">工具一：基本面分析</p>
                <p>
                  聚焦北向资金、融资余额、股债收益差、宏观经济指标以及货币供应量等基本面数据与大盘指数的联动效应，研判主力资金动态，把握市场趋势，规避系统性风险。
                </p>
                <p>
                  二级市场分析：通过研究北向资金、融资余额、腾落指数、平均成交额*换手率、股债收益差等二级市场数据，明晰股市的资金流向和持仓结构，发现市场主力的交易意图和心理状态，研判股市的供需关系和买卖氛围。
                </p>
                <Imggs
                  :src="require('../../assets/img/jbm1.jpg')"
                  alt=""
                  @click.native="
                    showimg(require('../../assets/img/jbm1.jpg'))
                  "
                  width="80%"
                />
                <p>经济面分析：叠加显示GDP增速、CPI环比、PPI环比曲线，分析经济增长动能及通胀水平，综合评估经济大环境对股市的支持或压制作用。</p>
                <Imggs
                  :src="require('../../assets/img/jbm2.jpg')"
                  alt=""
                  @click.native="
                    showimg(require('../../assets/img/jbm2.jpg'))
                  "
                  width="80%"
                />
                <p>货币面分析：对比分析M1、M2环比增速，以及社融增量数据，通过货币供应量及流动性分析股市资金供给情况，研判股价上涨和下跌动力。</p>
                <Imggs
                  :src="require('../../assets/img/jbm3.jpg')"
                  alt=""
                  @click.native="
                    showimg(require('../../assets/img/jbm3.jpg'))
                  "
                  width="80%"
                />
              </div>
              <div v-if="showlist[1]">
                <p class="title" id="id3">工具二：板块化分析</p>
                <p>
                  通过对大盘指数中各行业板块权重、市值、股票家数、贡献度等数据进行排序分析，把握板块流动节奏，研究市场情绪变化。
                </p>
                <p>
                进一步构造虚拟指数，了解指数涨跌源头，提高选股胜率，优化资产配置，发现更多阶段性投资机会，避免“赚了指数没赚钱”。
                </p>
                <Imggs
                  :src="require('../../assets/img/bkhfx1.jpg')"
                  alt=""
                  @click.native="
                    showimg(require('../../assets/img/bkhfx1.jpg'))
                  "
                  width="80%"
                />
              </div>
             
            </div>
          </div>
        </div>
      </div>
    </div>
    <Baseimg :src="src" :show="ifimg" @change="ifimg = false" />
  </div>
</template>

<script>
import Baseimg from "./frame/Baseimg.vue";
import Imggs from "./frame/Imggs.vue";
export default {
  components: { Baseimg, Imggs },
  data() {
    return {
      leftList: [
        // { name: "三键下单工具",idx:0 },
        // // { name: "盘口炒单工具" },
        // // { name: "网格策略工具" },
        // { name: "T+0持仓列表",idx:2  },
        // { name: "分批下单" },
        // { name: "文件下单" },
        { name: "基本面分析",idx:0  },
        { name: "板块化分析",idx:1  },
        // { name: "宏观分析工具" },
        // { name: "行业分析工具" },
      ],
      showlist: [true, false, ],
      selectIndex: 0,
      src: "",
      ifimg: false,
    };
  },
  methods: {
    select(index) {
      this.showlist.forEach((el, idx) => {
        this.showlist[idx] = false;
      });
      this.showlist[index] = true;
      this.selectIndex = index;
      // this.custormAnchor(`id${index + 1}`);
    },
    showimg(e) {
      console.log(e);
      this.src = e;
      this.ifimg = true;
    },
    // custormAnchor(anchorName) {
    //   var target = document.getElementById(anchorName);
    //   if (target !== null) {
    //     this.$refs.box.scrollTop = target.offsetTop;
    //   }
    // },
  },
  mounted() {
    this.select(this.$route.params.id);
  },
};
</script>

<style scoped>
.packkua {
  width: 900px;
  margin: 0 auto;
  min-height: 0px;
  margin-top: 50px;
}
.packh4 {
  background: #f5e5e5;
  height: 25px;
}
.h4img {
  float: left;
  margin-top: -12px;
}
.imgcontainer {
  padding: 0 10px;
  background: #f5f5f5;
}
.h4ti {
  width: 95px;
  border-radius: 0 0 30px 0;
  background: #e04a49;
  float: left;
  height: 25px;
  color: white;
  line-height: 24px;
  font-size: 16px;
  padding-left: 7px;
}
.kuatxt {
  padding: 20px 0 40px 0;
  width: 100%;
}
.kuatxt p {
  line-height: 25px;
  padding: 10px 0;
  font-size: 14px;
  text-indent: 2em;
  color: #6f6f6f;
  text-align: justify;
}
.plantht {
  min-height: 600px;
  background: url(https://wh-api.wenhua.com.cn/api/WhBanner/GetWhBannerUrl?id=11) no-repeat top;
  overflow: hidden;
}
.planttxt {
  width: 990px;
  border-radius: 5px;
  margin: 0 auto;
  margin-top: 236px;
  padding: 30px 30px 0 30px;
  background: white;

  box-shadow: 0 0 20px -5px #ccc;
}
.planth5 {
  font-size: 22px;
  color: #5f5f5f;
  border-bottom: 1px dashed #7f7f7f;

  line-height: 40px;
}
.planth4 {
  background: #ffe9dc;
  height: 25px;
  width: 920px;
}
.h4ti1 {
  width: 111px;
  border-radius: 0 0 30px 0;
  background: #e0a180;
  float: left;
  height: 25px;
  color: white;
  line-height: 24px;
  font-size: 16px;
  padding-left: 7px;
}
.kuatxt p {
  width: 600px;
  line-height: 25px;
  text-align: justify;
}
.kuatxt {
  width: 600px;
  display: inline-block;
}
.imgs {
  display: inline-block;
  margin-left: 30px;
}
.imgtop div {
  color: #292929;
  text-indent: 2em;
  font-size: 15px;
  padding: 5px 0;
}
.container {
  width: 100%;
  position: relative;
  background: white;
  margin-top: 20px;
}
.right_part::-webkit-scrollbar {
  width: 0;
}
.left_part {
  display: inline-block;
  width: 195px;
  height: 100%;
}
.left_part .title {
  width: calc(100% - 20px);
  height: 45px;
  line-height: 45px;
  font-size: 16px;
  /* font-weight: bold; */
  background: url(../../assets/img/ts2.jpg) no-repeat center;
  background-size: 100% 100%;
  vertical-align: top;
  color: #fff;
  padding-left: 20px;
}
.left_part ul li {
  height: 50px;
  line-height: 50px;
  cursor: pointer;
  font-size: 15px;
  color: #827373;
  border-bottom: 1px solid #ececec;
}
.left_part ul li:hover {
  color: #b56f6f;
}
.left_part ul li.active {
  background: #e57373;
  /* box-shadow: 2px 4px 4px #bebcbc inset; */
  color: white;
}
.left_part ul li a {
  width: 85%;
  margin: 0 auto;
  display: block;
  text-indent: 1em;
  position: relative;
  top: -1px;
}
.left_part ul li.active  a{
  border-bottom: none;
}
.right_part {
  display: inline-block;
  width: 695px;
  height: 100%;
  vertical-align: top;
  background: #f5f5f5;
  padding: 20px 40px;
  color: #8a8a8a;
  /* box-shadow: -4px 4px 4px #bebcbc inset; */
  background: #efefef;
}
.right_part p {
  text-indent: 2em;
  padding: 5px 0;
  font-size: 14px;
  text-align: justify;
  line-height: 24px;
}
.right_part img {
  margin: 20px auto;
  display: block;
}
.right_part .title {
  font-size: 16px;
  font-weight: bold;
  text-indent: 0;
  color: #7e4040;
}
p a {
  color: rgb(43, 100, 179);
}
</style>